import { EyewitnessPost, PostPetition } from "../interface/api";
import Axios from "../utils/http-request";
import { getAccessToken } from "../utils/storage";

export const apiGetPosts = async () => {
  // Get access token
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/posts?page=&page_size=`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.details || e?.details,
    };
  }
};

export const apiGetPostDetails = async (post_id: number) => {
  // Get access token
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/posts/${post_id}`;

    // Get request configuration (assuming this function provides headers, etc.)
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
      },
    };

    // Send the GET request
    const result = await Axios.get(uri, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.message || e?.details,
    };
  }
};

export const apiPostPetition = async (values: PostPetition) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/posts`;
    const formData = new FormData();

    // Prepare and add each file to FormData

    // If files is an array
    if (Array.isArray(values?.media)) {
      values?.media.forEach((file) => {
        formData.append("media[]", file);
      });
    }
    if (Array.isArray(values?.target_representative_ids)) {
      values?.target_representative_ids.forEach((id) => {
        formData.append("target_representative_ids[]", id);
      });
    }

    // // Ensure the array exists
    // if (Array.isArray(values?.target_representative_ids)) {
    //   values.target_representative_ids.forEach((target) => {
    //     // Convert to string if necessary
    //     formData.append("target_representative_ids[]", target);
    //   });
    // } else {
    //   console.error("target_representative_ids is not an array");
    // }

    // Append all form fields to FormData
    Object.entries(values).forEach(([key, value]) => {
      if (key === "media" || key === "target_representative_ids") {
      } else {
        formData.append(key, value.toString());
      }
    });

    // Wait for all files to be prepared

    // // Optional: Add additional form fields if needed
    // formData.append("post_type", values.post_type);
    // formData.append("title", values.title);
    // formData.append("context", values.context);
    // formData.append("target_signatures", values.target_signatures);
    // formData.append(
    //   "target_representative_id",
    //   values.target_representative_ids
    // );

    // Set up headers for the request
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
      },
    };

    // Send the POST request
    const result = await Axios.post(uri, formData, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.message || e?.details,
    };
  }
};

export const apiPostEyeReport = async (values: EyewitnessPost) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/posts`;
    const formData = new FormData();

    // If files is an array
    if (Array.isArray(values?.media)) {
      values?.media.forEach((file) => {
        formData.append("media[]", file);
      });
    }
    // Append all form fields to FormData
    Object.entries(values).forEach(([key, value]) => {
      if (key !== "media") {
        formData.append(key, value.toString());
      }
    });

    // Set up headers for the request
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
        "Content-Type": "multipart/form-data",
      },
    };
    // Send the POST request
    const result = await Axios.post(uri, formData, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);
    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.message || e?.details,
    };
  }
};

export const apiLikePost = async (post_id: number) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/posts/${post_id}/like`;
    const formData = new FormData();

    // Set up headers for the request
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
      },
    };
    // Send the POST request
    const result = await Axios.post(uri, formData, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);
    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.message || e?.details,
    };
  }
};

export const apiBookmarkPost = async (post_id: number) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/posts/${post_id}/bookmark`;
    const formData = new FormData();

    // Set up headers for the request
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
      },
    };
    // Send the POST request
    const result = await Axios.post(uri, formData, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);
    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.message || e?.details,
    };
  }
};
export const apiReportPost = async (post_id: number, reason: string) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/posts/${post_id}/report?reason=${reason}`;

    // Set up headers for the request
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
      },
    };
    // Send the POST request
    const result = await Axios.post(uri, {}, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);
    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.message || e?.details,
    };
  }
};

export const apiRepostPost = async (post_id: number) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/posts/${post_id}/repost`;
    const formData = new FormData();

    // Set up headers for the request
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
      },
    };
    // Send the POST request
    const result = await Axios.post(uri, formData, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);
    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.message || e?.details,
    };
  }
};

export const apiSignPetition = async (values: {
  post_id: number;
  comment: string;
}) => {
  const { accessToken, tokenType } = await getAccessToken();
  try {
    const uri = `/posts/petitions/${values?.post_id}/sign`;
    const data = JSON.stringify({ comment: values?.comment });

    // Set up headers for the request
    const cfg = {
      headers: {
        Authorization: `${tokenType} ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    // Send the POST request
    const result = await Axios.post(uri, data, cfg);

    // Return the result
    return result;
  } catch (e: any) {
    console.error(e);

    // Return error response
    return {
      data: {},
      status: "error",
      details: e?.response?.data?.message || e?.details,
    };
  }
};
